// extracted by mini-css-extract-plugin
export default {"logo":"styles_logo__K9THJ","centeredElement":"styles_centeredElement__Aknit"};